import { ajaxSuccess } from './helpers';

const EDIT_ANSWER_BTN_SPINNER = `<i class="fa fa-circle-notch fa-spin m-auto text-primary"></i>`;

const _setupAnswerContainer = (text) => `<div class="">${text}</div>`;

$(document).on('submit', '.new-answer-form', async function(e) {
    e.preventDefault();
    const $this = $(this)
    const $input = $(this).find('input[name="answer_text"]')
    const _answerText = $input.val().trim()

    if(!_answerText.length || $this.attr('disabled')) return;

    $this.attr('disabled', true)
    $this.find('button[type="submit"]').showLoading()
    
    axios({
        method: 'POST',
        url: $this[0].action,
        data: {
            answer_text: _answerText
        },
        errorHandler: true
    })
    .then((res) => {
        ajaxSuccess(res)
        $this.removeAttr('disabled')
        $this.find('button[type="submit"]').hideLoading()
        
        if(res?.data?.data?.answer) {
            $input.val(null)
            $this.find('.new-question-overlay').fadeOut(150, function() {
                this.remove();
            })
            const $newAnswer = $(`<div class="col-12 collapse" data-answer-column>${res.data.data.answer}</div>`);
            $this.closest('.form-answers').find('[data-answers]').append($newAnswer)
            $newAnswer.collapse('show')
        } else {
            window.location.reload()
        }
    }, (err) => {
        $this.find('.new-question-overlay').fadeOut(150, function() {
            this.remove();
        })
        $this.removeAttr('disabled')
        $this.find('button[type="submit"]').hideLoading()
    })
})

$(document).on('click', '.btn-answer-delete', function(e) {
    const { href, answerId } = this.dataset;
    axios({
        method: 'DELETE',
        url: href,
    })
    .then((res) => {
        ajaxSuccess(res);
        $(`#deleteAnswer-${answerId}`).modal('hide')
        $(`.form-box[data-answer-id="${answerId}"]`)
        .parent()
        .collapse('hide')
        return true;
    })
})

$(document).on('click', '.answer-box .btn-answer-edit', function(e) {
    const self = this;
    const $content = $(this).closest('.answer-box').find('.box-body')
    const $answerDesc = $content.find('.answer-description')

    if($content.find('form.edit-answer-form').length) {
        const _text = $content.find('form.edit-answer-form input[name="answer_text"]').val()

        $answerDesc.get(0).oldData = {
            type: 'formData',
            value: _text
        }

        $answerDesc.collapse('hide')

        return;
    }

    const _tpl = $content[0].querySelector('template.edit-answer-container').content.cloneNode(true)
    _tpl.querySelector('input[name="answer_text"]').value = $content.text().trim()

    $answerDesc.get(0).oldData = {
        type: 'tpl',
        value: $content.text().trim()
    } 

    $answerDesc.collapse('hide')
})
$(document).on('shown.bs.collapse', '.answer-box .answer-description', function(e) {
    const $content = $(this).closest('.answer-box').find('.box-body')
    if($content.find('form.edit-answer-form').length) {
        $content.find('input[name="answer_text"]').trigger('focus')
    }
})
$(document).on('hidden.bs.collapse', '.answer-box .answer-description', function(e) {
    const { oldData } = $(this).get(0)
    let _tpl;

    if(oldData.type === 'tpl') {
        const $content = $(this).closest('.answer-box').find('.box-body')
        _tpl = $content[0].querySelector('template.edit-answer-container').content.cloneNode(true)
        _tpl.querySelector('input[name="answer_text"]').value = oldData.value
    } else {
        _tpl = _setupAnswerContainer(oldData.value)
    }

    $(this)
    .html(_tpl)
    .collapse('show')
})

$(document).on('submit', 'form.edit-answer-form', function(e) {
    e.preventDefault()
    const self = this
    
    const $btn = this.querySelector('button[type="submit"]')
    $btn.setAttribute('disabled', true)
    const _oldBtnContent = $btn.innerHTML;
    $btn.innerHTML = EDIT_ANSWER_BTN_SPINNER;

    const _answer = Array.from(this.elements)
    .find(el => el.name == 'answer_text')
    .value

    axios({
        method: 'PATCH',
        url: this.action,
        data: {
            answer_text: _answer
        },
        errorHandler: true
    })
    .then((res) => {
        ajaxSuccess(res);
        const { data: { answer } } = res.data
        const $content = $(self).closest('.form-description.answer-description')

        $content.get(0).oldData = {
            type: 'formData',
            value: answer
        } 

        $content.collapse('hide')
    }, (err) => {
        $btn.innerHTML = _oldBtnContent
        $btn.removeAttribute('disabled')
    })
})